import {
  ProductSwitchContextProto,
  RecommendationContextProto,
} from "@noom/noom-contracts/noom_contracts/recommender/shared";
import getStore from "../redux/store";
import { trackBuyflowEvent } from "../api/tracker";
import { MED_SKU } from "../medEligibility";
import { getMedSKUByProductName } from "../plans";
import { PlanSelectionOption } from "src/pages/payment/results/medPlanSelection";

function getMedTierItemIdMap(): Record<MED_SKU, string> {
  return {
    [MED_SKU.BRANDED_WEGOVY_PILL]: "medBrandedWegovyPillPlan",
    [MED_SKU.COMPOUNDED_TIRZEPATIDE]: "medCompoundedTirzepatidePlan",
    [MED_SKU.COMPOUNDED_MICRODOSE_TIRZEPATIDE]:
      "medCompoundedMicrodoseTirzepatidePlan",
    [MED_SKU.BRANDED_ZEPBOUND_VIAL]: "medBrandedZepboundVialPlan",
    [MED_SKU.BRANDED]: "medBrandedPlan",
    [MED_SKU.COMPOUNDED]: "medCompoundedPlan",
    [MED_SKU.GENERIC_LIRAGLUTIDE]: "medLiraglutidePlan",
    [MED_SKU.ORALS_METFORMIN]: "medOralsPlan",
    [MED_SKU.HRT_CREAM]: "hrtCreamPlan",
    [MED_SKU.HRT_PATCH]: "hrtPatchPlan",
    [MED_SKU.COMPOUNDED_MICRODOSE]: "medMicrodosePlan",
    [MED_SKU.COMPOUNDED_MICRODOSE_PROACTIVE_HEALTH_BIOMARKER]:
      "medProactiveHealthMicrodoseBiomarkerPlan",
  };
}

export function getRecommendationContextProto(
  option: PlanSelectionOption
): RecommendationContextProto {
  const { userData, recommendationContext, productSwitch } =
    getStore().getState();
  const growthUserId = userData.user_id;
  const recommendationId = recommendationContext?.recommendationId;
  const currentProductName = productSwitch.currentSubscription?.productName;

  if (option === "NOOM_WEIGHT") {
    return {
      itemId: "noomWeight",
      userId: { growthUserId },
      recommendationSurface: "MED_PLAN_OFFER",
      positionViewed: recommendationContext?.eligibleMedTiers?.length,
      recommendationId,
      currentProductName,
    };
  }

  const positionViewed =
    recommendationContext?.eligibleMedTiers?.indexOf(option);

  const medTierItemIdMap = getMedTierItemIdMap();

  const offer = productSwitch.offers.find(
    (o) => getMedSKUByProductName(o.productName) === option
  );

  return {
    itemId: medTierItemIdMap[option],
    userId: { growthUserId },
    recommendationSurface: "MED_PLAN_OFFER",
    positionViewed,
    recommendationId,
    productName: offer?.productName,
    currentProductName,
  };
}

function getProductSwitchContextProto(
  option: PlanSelectionOption
): ProductSwitchContextProto | undefined {
  const { productSwitch } = getStore().getState();
  const offer = productSwitch.offers.find(
    (o) => getMedSKUByProductName(o.productName) === option
  );
  if (!offer?.switchOperation) {
    return undefined;
  }
  const immediateSwitch =
    // eslint-disable-next-line no-underscore-dangle
    offer.switchOperation.switchType?.__typename === "ImmediateSwitch";
  return {
    isImmediateSwitch: immediateSwitch,
    isNewTrial: !!offer.switchOperation.trialSaleItemId,
  };
}

export function trackRecommendedOfferClicked(option: PlanSelectionOption) {
  trackBuyflowEvent("BuyflowRecommendedItemClicked", {
    recommendationContext: getRecommendationContextProto(option),
    productSwitchContext: getProductSwitchContextProto(option),
  });
}

export function trackRecommendedOfferViewed(option: PlanSelectionOption) {
  trackBuyflowEvent("BuyflowRecommendedItemViewed", {
    recommendationContext: getRecommendationContextProto(option),
    productSwitchContext: getProductSwitchContextProto(option),
  });
}

export function trackRecommendedOfferDeclined(medTier: MED_SKU) {
  trackBuyflowEvent("BuyflowRecommendedItemDeclined", {
    recommendationContext: getRecommendationContextProto(medTier),
    productSwitchContext: getProductSwitchContextProto(medTier),
  });
}
